import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/notFound/notFound'
import Login from '@/components/login/login'
import Layouts from '@/components/layouts/layouts'
import MyMap from '@/components/map/map'
import VillageSurvey from '@/components/village/villageSurvey'
import VillageDetail from '@/components/village/villageDetail'
import BuildingDetail from '@/components/village/buildingDetail'
import LiftDetail from '@/components/village/liftDetail'
import Card from '@/components/card/card'
import ByLiftRecord from '@/components/lift/byLiftRecord'
import FloorManage from '@/components/village/floorManage'
import Room from '@/components/room/room'
import Owner from '@/components/user/owner'
import OwnerDetail from '@/components/user/ownerDetail'
import OwnerFamilyByLift from '@/components/user/ownerFamilyByLift'
import Orgmanager from '@/components/user/orgmanager'
import OrgmanagerDetail from '@/components/user/orgmanagerDetail'
import LiftManage from '@/components/lift/liftManage'
import Order from '@/components/order/order'
import OrderDetail from '@/components/order/orderDetail'
import Role from '@/components/system/role'
import Person from '@/components/system/person'
import Permission from '@/components/system/permission'
import SubMenu from '@/components/system/subMenu'
import FunModel from '@/components/system/funModel'
import OperationLog from '@/components/system/operationLog'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Layouts',
      component: Layouts,
      children: [
        {
          path: '/map',
          name: 'Map',
          component: MyMap
        },
        {
          path: '/villageSurvey',
          name: 'VillageSurvey',
          component: VillageSurvey
        },
        {
          path: '/villageDetail',
          name: 'VillageDetail',
          component: VillageDetail
        },
        {
          path: '/buildingDetail',
          name: 'BuildingDetail',
          component: BuildingDetail
        },
        {
          path: '/liftDetail',
          name: 'LiftDetail',
          component: LiftDetail
        },
        {
          path: '/card',
          name: 'Card',
          component: Card
        },
        {
          path: '/byLiftRecord',
          name: 'ByLiftRecord',
          component: ByLiftRecord
        },
        {
          path: '/floorManage',
          name: 'FloorManage',
          component: FloorManage
        },
        {
          path: '/room',
          name: 'Room',
          component: Room
        },
        {
          path: '/owner',
          name: 'Owner',
          component: Owner
        },
        {
          path: '/ownerDetail',
          name: 'OwnerDetail',
          component: OwnerDetail
        },
        {
          path: '/ownerFamilyByLift',
          name: 'OwnerFamilyByLift',
          component: OwnerFamilyByLift
        },
        {
          path: '/orgmanager',
          name: 'Orgmanager',
          component: Orgmanager
        },
        {
          path: '/orgmanagerDetail',
          name: 'OrgmanagerDetail',
          component: OrgmanagerDetail
        },
        {
          path: '/liftManage',
          name: 'LiftManage',
          component: LiftManage
        },
        {
          path: '/order',
          name: 'Order',
          component: Order
        },
        {
          path: '/orderDetail',
          name: 'OrderDetail',
          component: OrderDetail
        },
        {
          path: '/role',
          name: 'Role',
          component: Role
        },
        {
          path: '/person',
          name: 'Person',
          component: Person
        },
        {
          path: '/permission',
          name: 'Permission',
          component: Permission
        },
        {
          path: '/subMenu',
          name: 'SubMenu',
          component: SubMenu
        },
        {
          path: '/funModel',
          name: 'FunModel',
          component: FunModel
        },
        {
          path: '/operationLog',
          name: 'OperationLog',
          component: OperationLog
        }
      ]
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})

// 路由跳转前
router.beforeEach((to, from, next) => {
  let token = !sessionStorage.getItem('token')
  let path = to.path
  if (token && (path === '/login' || path === '/notFound' || path === '/map')) {
    next()
  } else if (token && path !== '/login' && path !== '/notFound' && path !== '/map') {
    next({
      path: '/login'
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js